import { useRouteError, Link } from 'react-router-dom';
import Navigation from '../navigation';
import Footer from '../footer';

const ErrorPage = () => {
  const error: any = useRouteError();
  console.error(error);

  return (
    <div className="site">
      <Navigation />
      <main className="site-main">
        <div className="error-page container">
          <div>
            <span className="eyebrow" style={{ justifyContent: 'center' }}>Lost in the woods</span>
            <h1>Oops!</h1>
            <p>Sorry, an unexpected error has occurred.</p>
            <p><i>{error?.statusText || error?.message}</i></p>
            <p style={{ marginTop: '2rem' }}>
              <Link to="/home" className="btn btn--primary">Back to home <span className="arrow">→</span></Link>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ErrorPage;
